import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

export default function DialogCampanhaRecusarFatura({
  open,
  onClose,
  faturaParaRecusar,
  motivoRecusaFatura,
  setMotivoRecusaFatura,
  gravarRecusaFatura,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
        Recusar / excluir fatura
      </DialogTitle>

      <DialogContent>
        <MDBox display="grid" gap={1.5} mt={1}>
          <MDTypography variant="caption">
            <b>Fatura:</b> {faturaParaRecusar?.faturaorigem || ""}
          </MDTypography>

          <MDTypography variant="caption">
            <b>Cliente:</b> {faturaParaRecusar?.cliente || faturaParaRecusar?.refcliente || ""}
          </MDTypography>

          <MDInput
            label="Motivo da recusa"
            value={motivoRecusaFatura}
            onChange={(e) => setMotivoRecusaFatura(e.target.value)}
            fullWidth
            multiline
            rows={4}
          />
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton color="secondary" onClick={onClose}>
          Cancelar
        </MDButton>

        <MDButton color="error" onClick={gravarRecusaFatura}>
          Recusar / excluir
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
